import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const [isBanned, setIsBanned] = useState<boolean | null>(null);

  useEffect(() => {
    async function checkBanned() {
      try {
        if (!user) {
          setIsBanned(false);
          return;
        }
        
        const timeout = setTimeout(() => {
          setIsBanned(false);
        }, 3000);
        
        const { data, error } = await supabase.rpc("has_role", {
          _user_id: user.id,
          _role: "banned",
        });
        
        clearTimeout(timeout);
        if (error) {
          console.warn("has_role RPC failed:", error);
          setIsBanned(false);
          return;
        }
        setIsBanned(!!data);
      } catch (e) {
        console.warn("checkBanned error:", e);
        setIsBanned(false);
      }
    }
    
    checkBanned();
  }, [user]);

  // 加载中显示加载指示器
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex items-center gap-2">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="text-muted-foreground">加载中...</span>
        </div>
      </div>
    );
  }

  // 未登录跳转到 auth 页面
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // 被封禁用户显示提示
  if (isBanned) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-destructive/10 flex items-center justify-center">
            <span className="text-3xl">🚫</span>
          </div>
          <h1 className="text-xl font-bold text-foreground mb-2">账户已被封禁</h1>
          <p className="text-muted-foreground mb-6">
            您的账户因违规行为已被封禁，如有疑问请联系客服。
          </p>
          <p className="text-sm text-muted-foreground">
            客服微信：shunlixiezuo168
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
